import * as React from 'react';

import Icon from './Icon';

import {colors} from '../../../styles/variables';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const ClearIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 16;
  const color = props.color || colors.paleGray;
  return <Icon name={'clear'} size={size} color={color} />;
};

export default React.memo(ClearIcon);
